import * as React from 'react';
import { HelpLine, NotificationLine } from '@dropbox/dig-icons/assets';
import { UtilityActionMenu } from './utility_action_menu';
import { Avatar } from '@dropbox/dig-components/avatar';
import { Badge } from '@dropbox/dig-components/badge';
/**
 * The notification bell entry point. For a full menu implementation, use `GlobalHeader.NotificationMenu`.
 *
 * Ideally all users should use the full `GlobalHeader.NotificationMenu`. This entry point is being left in
 * code to aid in the transition to the full component.
 */
export const Notifications = ({ children, hasNotifications, ...rest }) => {
    return (React.createElement(UtilityActionMenu, { ...rest, iconSrc: NotificationLine, customTriggerContents: hasNotifications ? (React.createElement(Badge, { className: "dpc-GlobalHeader-NotificationBadge" })) : undefined }, children));
};
Notifications.displayName = 'Notifications';
export const Help = ({ hasProductUpdates = false, children, tooltipTitle, ...rest }) => {
    return (React.createElement(UtilityActionMenu, { ...rest, iconSrc: HelpLine, tooltipTitle: tooltipTitle, customTriggerContents: hasProductUpdates ? (React.createElement(Badge, { className: "dpc-GlobalHeader-NotificationBadge" })) : undefined, slideSubmenu: true }, children));
};
Help.displayName = 'Help';
export const AccountMenu = ({ children, initials, triggerProps, wrapperActionProps, menuContentProps, tooltipTitle, ...rest }) => {
    return (React.createElement(UtilityActionMenu, { triggerProps: triggerProps, wrapperActionProps: wrapperActionProps, menuContentProps: menuContentProps, tooltipTitle: tooltipTitle, customTriggerContents: React.createElement(Avatar, { ...rest, size: "small", hasNoOutline: true }, initials) }, children));
};
AccountMenu.displayName = 'AccountMenu';
